require('../../../assets/scripts/common/directives/jv.Datepicker.js');
require('../../../assets/scripts/common/jv.Modal.js');
require('../../../assets/scripts/jhire/services/jv.services.js');
require('../../../assets/scripts/common/jv.currentUser.service.js');
require('../../../assets/scripts/common/jv.Filters.js');
require('../../../assets/scripts/common/jv.Loading.js');
require('../../../assets/scripts/source/jobvites/JV.MainJobvite.js');
require('../../../assets/lib/select2/select2-3.4.5/select2.min.js');
require('../../../assets/scripts/source/jobvites/JV.Jobvite.js');
require('../../../assets/scripts/source/jobvites/JV.RefApplications.js');
require('../../../assets/lib/js/angularmodule/angservice.js');
require('../../../assets/lib/js/angularmodule/JV.Core.Directives.js');
require('../../../assets/lib/jquery/jquery-ui-1.13.2.min.js');
require('../../../assets/lib/js/JV.FriendWidget_js_upgrade.js');